const dev = process.env.NODE_ENV !== 'production'
export const redirect_uri = dev ? 'https://test2.uralmusicnight.ru' : 'https://uralmusicnight.ru'

export const Links = {
  vkAuth: `https://oauth.vk.com/authorize?client_id=6975728&display=page&redirect_uri=${redirect_uri}&scope=friends&response_type=code&v=5.95&state=vk`, // eslint-disable-line
  // fbAuth: `https://www.facebook.com/v3.3/dialog/oauth?client_id=805153449840662&redirect_uri=${redirect_uri}&response_type=token&state=fb&scope=email` // eslint-disable-line
}

Links
